// extracted by mini-css-extract-plugin
module.exports = {"center":"style_center__1L-5t","windowedCenter":"style_windowedCenter__1yWxG"};